import { authenticatedFastApiAxiosInstanceAllowEmptyString } from "@/lib/data/http";
import { type APIResponse, type MatterSettlementOffer } from "@/lib/types";
import { baseFastApiMatterRoute } from "./matter";

const baseFastApiMatterSettlementOffersRoute = `${baseFastApiMatterRoute}/settlement-offers`;

type MatterSettlementOfferWritePayload = Omit<
  Partial<MatterSettlementOffer>,
  "attorneyFeeAmount" | "connections"
>;

export type CreateMatterSettlementOfferInput =
  MatterSettlementOfferWritePayload;
export type UpdateMatterSettlementOfferInput = Pick<
  MatterSettlementOffer,
  "id" | "matterId" | "dateModified"
> &
  MatterSettlementOfferWritePayload;

const serializeMatterSettlementOfferWritePayload = (
  data: MatterSettlementOfferWritePayload,
) => {
  const payload = { ...data } as Partial<MatterSettlementOffer>;
  delete payload.attorneyFeeAmount;
  delete payload.connections;
  return payload;
};

export const createMatterSettlementOfferV1 = (
  data: CreateMatterSettlementOfferInput,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<
      APIResponse<MatterSettlementOffer>
    >(baseFastApiMatterSettlementOffersRoute, serializeMatterSettlementOfferWritePayload(data))
    .then((res) => res.data);
};

export const deleteMatterSettlementOfferV1 = (
  data: Pick<MatterSettlementOffer, "id" | "matterId">,
) => {
  const { id } = data;

  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .delete<
      APIResponse<MatterSettlementOffer>
    >(`${baseFastApiMatterRoute}/settlement-offers/${id}`)
    .then((res) => res.data);
};

export const updateMatterSettlementOfferV1 = (
  data: UpdateMatterSettlementOfferInput,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<
      APIResponse<MatterSettlementOffer>
    >(baseFastApiMatterSettlementOffersRoute, serializeMatterSettlementOfferWritePayload(data))
    .then((res) => res.data);
};
